import { IUserChoice } from "../types/settings";

/**
 * The BeforeInstallPromptEvent is fired at the Window.onbeforeinstallprompt handler
 * before a user is prompted to "install" a web site to a home screen on mobile.
 *
 * @deprecated Only supported on Chrome and Android Webview.
 */
interface BeforeInstallPromptEvent extends Event {
  /**
   * Returns an array of DOMString items containing the platforms on which the event was dispatched.
   * This is provided for user agents that want to present a choice of versions to the user such as,
   * for example, "web" or "play" which would allow the user to chose between a web version or
   * an Android version.
   */
  readonly platforms: Array<string>;

  /**
   * Returns a Promise that resolves to a DOMString containing either "accepted" or "dismissed".
   */
  readonly userChoice: Promise<{
    outcome: "accepted" | "dismissed";
    platform: string;
  }>;

  /**
   * Allows a developer to show the install prompt at a time of their own choosing.
   * This method returns a Promise.
   */
  prompt(): Promise<void>;
}

const UtilsPWA: { deferredPrompt: BeforeInstallPromptEvent | null } = {
  deferredPrompt: null,
};

//
// We put it here to catch the events as soon as possible and not only when the component is mounted
//
window.addEventListener("beforeinstallprompt", (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Stash the event so it can be triggered later.
  UtilsPWA.deferredPrompt = e as BeforeInstallPromptEvent;
});

window.addEventListener("appinstalled", () => {
  // Log install to analytics
  console.log("INSTALL: Success");
});

export const isPwaInstalled = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};

export const pwaInstall = async (setIsInstall?: () => void) => {
  if (isPwaInstalled()) {
    alert("App is installed");
    return;
  }
  if (UtilsPWA.deferredPrompt) {
    UtilsPWA.deferredPrompt.prompt();
    UtilsPWA.deferredPrompt.userChoice.then((choiceResult: IUserChoice) => {
      if (choiceResult.outcome === "accepted") {
        alert("App installed successfully");
        setIsInstall?.();
      } else {
        console.info("User opted out from installing");
      }
    });
  } else {
    alert("App is installed");
  }
};
